<table class="search-result-parcel">
    <tr>
        <td>
            <div
                class="result-content"
                [ngStyle]="{
                    height:
                        (result.status === 'Inactive' || result.status === 'Active (Pending)') && result.soldDate
                            ? '110px'
                            : 'auto',
                }"
            >
                @if (
                    childEntity === 'taxBill' || childEntity === 'refund' || childEntity === 'parcel' || !childEntity
                ) {
                    <h4 class="m-0 fw-bold">
                        {{ result.primaryAcctNum }}
                        @if (childEntity === 'taxBill' || childEntity === 'refund') {
                            <span>[{{ result.additionalDesc }}]</span>
                        }
                    </h4>
                }
                @if (childEntity === 'assessment' || childEntity === 'appeal' || childEntity === 'filing') {
                    <h4 class="m-0 fw-bold">{{ result.firstLine }}</h4>
                }
                <strong
                    >{{ result.siteName }} | {{ result.siteCity }}
                    @if (result.siteCity) {
                        <span>, </span>
                    }
                    {{ result.siteState }}</strong
                >
                <p class="mb-0">{{ result.companyName }}</p>
                @for (num of acctNums; track num) {
                    <p class="mb-0">{{ num.label }}: {{ num.number }}</p>
                }
            </div>
            <div class="parcel-status-fields">
                <!-- Inactive Flag -->
                @if (result.status === 'Inactive') {
                    <img src="/images/inactive.jpg" alt="Inactive" class="status-img" />
                }
                <!-- Active Pending Flag -->
                @if (result.status === 'Active (Pending)') {
                    <img src="/images/active-pending.jpg" alt="Active (Pending)" class="status-img" />
                }
                <!-- Sold Flag -->
                @if (result.soldDate) {
                    <img
                        src="/images/sold.png"
                        [ngStyle]="{
                            'margin-top':
                                result.status === 'Inactive' || result.status === 'Active (Pending)' ? '40px' : '0px',
                        }"
                        alt="Sold"
                        class="status-img"
                    />
                }
            </div>
        </td>
        <td class="result-parcel-prop-type">
            <parcel-icon class="ws-display-inline-block" [parcel]="result" propTypeParam="propertyType" size="large">
            </parcel-icon>
        </td>
    </tr>
</table>
